<template>
  <div class="product-bubble-wrapper" :class="iconClassName">
    <div v-show="showBubble" class="product-bubble warehouse-icon-bubble" @mouseover="handleMouseOver()" @mouseleave="handleMouseLeave()">{{ warehouseName }}</div>
    <img class="img-responsive" :class="imageClassName" :src="iconImage" @mouseover="handleMouseOver()" @mouseleave="handleMouseLeave()">
  </div>
</template>

<script>
export default {
  props: {
    iconImage: {
      type: String,
      default: null
    },
    warehouseName: {
      type: String,
      default: null
    },
    iconClassName: {
      type: String,
      default: null
    },
    imageClassName: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      showBubble: false
    }
  },
  methods: {
    handleMouseOver () {
      this.showBubble = true
    },
    handleMouseLeave () {
      this.showBubble = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/productsNew/WarehouseIcon.vue